var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFaceRecognition = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 98,
  height: 98,
  viewBox: "0 0 98 98",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.6009 2.2002H14.2012C7.57375 2.2002 2.20117 7.57278 2.20117 14.2002V24.6641",
  stroke: "#97E946",
  strokeWidth: 3,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6009 95.7998H14.2012C7.57375 95.7998 2.20117 90.4272 2.20117 83.7998V73.3359",
  stroke: "#97E946",
  strokeWidth: 3,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M72.401 2.2002H83.8008C90.4282 2.2002 95.8008 7.57278 95.8008 14.2002V24.6641",
  stroke: "#97E946",
  strokeWidth: 3,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M72.401 95.7998H83.8008C90.4282 95.7998 95.8008 90.4272 95.8008 83.7998V73.3359",
  stroke: "#97E946",
  strokeWidth: 3,
  strokeLinecap: "round"
})));
export { SvgFaceRecognition as ReactComponent };